import { Box, Typography } from '@mui/material';

import { CAROUSEL_EPISODES_LIMIT } from '@/constants';
import { EpisodeCardPlaceholder } from '@/containers';

interface EpisodeCardCarouselEmptyPlaceholderProps {
  title: string;
  Link?: React.ComponentType;
}

export const EpisodeCardCarouselEmptyPlaceholder = ({
  title,
  Link,
}: EpisodeCardCarouselEmptyPlaceholderProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}>
        <Box>{title && <Typography variant="h4">{title}</Typography>}</Box>
        {Link && <Link />}
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {Array.from({ length: CAROUSEL_EPISODES_LIMIT }).map((_, index) => (
          <Box key={index} sx={{ flexShrink: 0 }}>
            <EpisodeCardPlaceholder />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
